/** Marca de recarga ya intentada. En sessionStorage: debe morir con la pestana. */
const CLAVE_RECARGA = 'chunk-reload';

/**
 * Recarga una vez cuando un chunk del build anterior ya no existe.
 *
 * Cada despliegue publica un slug nuevo con hashes nuevos y borra el anterior,
 * asi que una pestana abierta durante el deploy pide assets que ya no estan.
 * Recargar trae el index.html nuevo y resuelve la sesion.
 *
 * La guarda es imprescindible: sin ella, un asset que falla por otra causa deja
 * la pestana recargando en bucle. Ver CANDIDATOS-GPC-8H, 477 eventos de una
 * sola sesion atrapada.
 */
const registrarRecargaPorChunk = () => {
  window.addEventListener('vite:preloadError', (event) => {
    // Sin preventDefault Vite relanza el error y el bucle seguiria vivo.
    event.preventDefault();

    try {
      if (sessionStorage.getItem(CLAVE_RECARGA)) return;
      sessionStorage.setItem(CLAVE_RECARGA, '1');
    } catch {
      // Modo privado o almacenamiento bloqueado: sin guarda no se recarga,
      // porque un bucle es peor que un fallo de carga visible.
      return;
    }

    window.location.reload();
  });
};

export default registrarRecargaPorChunk;
